var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-8 container m-auto"},[_c('app-nav',{attrs:{"showNav":false}}),_c('div',{staticClass:"w-full lg:w-1/2 pt-4 px-4 m-auto"},[_c('add-record-form',{attrs:{"text":_vm.url},on:{"complete":_vm.close}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }